"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _ModalConfirmationMessage = _interopRequireDefault(require("../ModalConfirmationMessage"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

/**
 * Compliance popup.
 *
 * When the true value is passed to the "isOpen" property,
 * a compliance check opens, starting with the "prompt" popup,
 * if "revertText" was also passed, then if compliance check fails, the "revert" popup will be shown.
 *
 * @function
 *
 * @param {object} props
 * @param {boolean} props.isOpen
 * @param {function (boolean): void} props.onFinish
 * @param {string} props.promptText
 * @param {string | number} [props.width='100%']
 * @param {string} [props.revertText='']
 * @param {string} [props.link='']
 * @param {function (): void} [props.onLinkVisited=() => {}]
 * @param {boolean} [props.preview=false]
 *
 * @returns {React.ReactNode}
 *
 * @example
 * const CreateContactComponent = () => {
 *   const [isPopupVisible, setIsPopupVisible] = useState(false);
 *
 *   return (
 *     <>
 *       <CompliancePopup
 *         isOpen={isPopupVisible}
 *         onFinish={
 *           isPassed => {
 *            if (isPassed) {
 *              alert('Yeah, you successfully passed compliance check');
 *            } else {
 *              alert('Oh wey, you are failed!');
 *           }
 *           setIsPopupVisible(false);
 *         }
 *         promptText="Compliance prompt popup text"
 *         revertText="compliance revert popup text"
 *         link="https://alyce.com"
 *       />
 *       <button onClick={() => setIsPopupVisible(true)}>
 *         Open compliance checking
 *       </button>
 *     </>
 *   );
 * };
 */
var CompliancePopup = function CompliancePopup(_ref) {
  var isOpen = _ref.isOpen,
      width = _ref.width,
      onFinish = _ref.onFinish,
      promptText = _ref.promptText,
      revertText = _ref.revertText,
      link = _ref.link,
      onLinkVisited = _ref.onLinkVisited,
      preview = _ref.preview;

  var _useState = (0, _react.useState)(true),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isPrompt = _useState2[0],
      setIsPrompt = _useState2[1];

  var isPromptOpen = isOpen && isPrompt;
  var isRevertOpen = isOpen && !isPrompt;
  var handlePromptSubmit = (0, _react.useCallback)(function () {
    onFinish(true);
    setIsPrompt(true);
  }, [onFinish]);
  var handlePromptDiscard = (0, _react.useCallback)(function () {
    if (!revertText) {
      onFinish(false);
      setIsPrompt(true);
    } else {
      setIsPrompt(false);
    }
  }, [onFinish, revertText]);
  var handleDiscard = (0, _react.useCallback)(function () {
    onFinish(false);
    setIsPrompt(true);
  }, [onFinish]);
  var handleLinkClick = (0, _react.useCallback)(function () {
    onLinkVisited();
    window.open(link, '_blank');
  }, [link, onLinkVisited]);

  var previewButton = /*#__PURE__*/_react["default"].createElement(_material.Box, {
    position: "absolute",
    bottom: 0,
    width: 1,
    pt: 2,
    display: "flex",
    justifyContent: "center",
    style: {
      transform: 'translateY(100%)'
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Button, {
    onClick: handleDiscard,
    className: "Button-Link",
    startIcon: /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      icon: "times"
    })
  }, "Close preview"));

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_ModalConfirmationMessage["default"], {
    width: width,
    variant: "info",
    icon: "check",
    title: "Compliance check",
    submitButtonText: "Yes, approved",
    cancelButtonText: "Not approved",
    onSubmit: handlePromptSubmit,
    onDiscard: handlePromptDiscard,
    isOpen: isPromptOpen,
    backdropStyles: {
      top: 0
    },
    paperStyles: preview ? {
      overflow: 'visible'
    } : {},
    afterActions: preview && previewButton
  }, promptText, link && /*#__PURE__*/_react["default"].createElement(_material.Box, {
    mt: 2
  }, /*#__PURE__*/_react["default"].createElement(_material.Button, {
    onClick: handleLinkClick,
    className: "Button-Link"
  }, link))), /*#__PURE__*/_react["default"].createElement(_ModalConfirmationMessage["default"], {
    width: width,
    variant: "info",
    icon: "times",
    title: "Compliance check",
    submitButtonText: "Got it",
    onSubmit: handleDiscard,
    onDiscard: handleDiscard,
    isOpen: isRevertOpen,
    submitButtonsProps: {
      fullWidth: true
    },
    backdropStyles: {
      top: 0
    },
    paperStyles: preview ? {
      overflow: 'visible'
    } : {},
    afterActions: preview && previewButton
  }, revertText, link && /*#__PURE__*/_react["default"].createElement(_material.Box, {
    mt: 2
  }, /*#__PURE__*/_react["default"].createElement(_material.Button, {
    onClick: handleLinkClick,
    className: "Button-Link"
  }, link))));
};

CompliancePopup.propTypes = {
  isOpen: _propTypes["default"].bool.isRequired,
  onFinish: _propTypes["default"].func.isRequired,
  promptText: _propTypes["default"].string.isRequired,
  onLinkVisited: _propTypes["default"].func,
  link: _propTypes["default"].string,
  revertText: _propTypes["default"].string,
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  preview: _propTypes["default"].bool
};
CompliancePopup.defaultProps = {
  link: '',
  revertText: '',
  width: '100%',
  onLinkVisited: function onLinkVisited() {},
  preview: false
};
var _default = CompliancePopup;
exports["default"] = _default;